import type { TOC } from '@ember/component/template-only';
import { array } from '@ember/helper';
import { PrismLoadingBar } from '@mylighthouse/prism-ember';
import { or } from 'ember-truth-helpers';
import SettingsCurrencyConversionLandingPage from 'lumen/components/settings/currency-conversion/landing-page';
import SettingsCurrencyConversionModalsNotFoundProfile from 'lumen/components/settings/currency-conversion/modals/not-found-profile';
import SettingsCurrencyConversionModalsOnboarding from 'lumen/components/settings/currency-conversion/modals/onboarding';
import type HotelSettingsCurrencyConversionIndexController from 'lumen/controllers/hotel/settings/currency-conversion/index';
import type HotelSettingsCurrencyConversionIndexRoute from 'lumen/routes/hotel/settings/currency-conversion/index';
import type { ModelFrom } from 'lumen/utils/routes';

interface HotelSettingsCurrencyConversionIndexSignature {
  Args: {
    controller: HotelSettingsCurrencyConversionIndexController;
    model: ModelFrom<HotelSettingsCurrencyConversionIndexRoute>;
  };
}

const HotelSettingsCurrencyConversionIndex: TOC<HotelSettingsCurrencyConversionIndexSignature> =
  <template>
    {{#if @model.exchangeRatesProfiles.isRunning}}
      <PrismLoadingBar />
    {{/if}}

    <SettingsCurrencyConversionLandingPage
      @baseCurrencies={{or @model.baseCurrencies.last.value (array)}}
      @exchangeRatesProfiles={{or
        @model.exchangeRatesProfiles.last.value
        (array)
      }}
      @isBannerDismissed={{@controller.isBannerDismissed}}
      @isLoading={{@model.exchangeRatesProfiles.isRunning}}
      @isReadOnly={{true}}
      @onDismissBanner={{@controller.dismissBanner}}
      @onNavigateToPortfolio={{@controller.navigateToPortfolio}}
      @portfolioAccess={{@controller.portfolioAccess}}
    />

    {{outlet}}

    {{#if @controller.showProfileNotFoundModal}}
      <SettingsCurrencyConversionModalsNotFoundProfile
        @onClose={{@controller.closeProfileNotFoundModal}}
      />
    {{/if}}

    {{#if @controller.showUserOnboardingModal}}
      <SettingsCurrencyConversionModalsOnboarding
        @onClose={{@controller.closeUserOnboardingModal}}
      />
    {{/if}}
  </template>;

export default HotelSettingsCurrencyConversionIndex;
